import { reactive } from 'vue';

// A simple reactive store for theme management
export const theme = reactive({
  logoUrl: null,
  primaryColor: '#0d6efd',   // Default Bootstrap primary color
  secondaryColor: '#6c757d', // Default Bootstrap secondary color
  budgetName: 'Catalog Viewer', // Default budget name

  /**
   * Sets the theme based on a budget object.
   * @param {object|null} budget - The budget object containing theme properties.
   */
  setTheme(budget) {
    // Set Logo URL
    if (budget && budget.logo && budget.logo.url) {
      this.logoUrl = `${process.env.VUE_APP_STRAPI_URL}${budget.logo.url}`;
    } else {
      this.logoUrl = null; // Or a path to a default logo
    }

    // Set Primary Color
    if (budget && budget.primary_color) {
      this.primaryColor = budget.primary_color;
    } else {
      this.primaryColor = '#0d6efd';
    }

    // Set Secondary Color
    if (budget && budget.secondary_color) {
      this.secondaryColor = budget.secondary_color;
    } else {
      this.secondaryColor = '#6c757d';
    }

    // Set Budget Name
    if (budget && budget.name) {
      this.budgetName = budget.name;
    } else {
      this.budgetName = 'Catalog Viewer';
    }
  },

  /**
   * Resets the theme to default values.
   */
  clearTheme() {
    this.logoUrl = null;
    this.primaryColor = '#0d6efd';
    this.secondaryColor = '#6c757d';
    this.budgetName = 'Catalog Viewer';
  }
});
